export enum KeyCodes {
    Enter = 13,
    ArrowUp = 38,
    ArrowRight = 39,
    ArrowDown = 40,
    ArrowLeft = 41,
    Tab = 9,
    Esc = 27,
}